import { ContactAnalysisStateConclusion } from '../../api/generated';

export function getCorrelatedConclusions(original: ContactAnalysisStateConclusion, others: ContactAnalysisStateConclusion[]) {
  const correlatedConclusions = others.filter(c => c.id !== original.id && c.correlationId === original.correlationId);
  return correlatedConclusions;
}